<template>
  <div class="users">
    <div class="content">
      <div class="wrap">
        <!-- [ Tree ] start -->
        <div class="wrap__tree">
          <div class="nav-tree">
            <el-button v-if="companyLayout2" :disabled="!companyLayout2.permission.inviteUser" @click="inviteUser" class="nav-tree__item" size="mini" type="menu" icon="el-icon-plus">{{$t('users_btn_invite')}}</el-button>
            <el-button v-if="companyLayout2" :disabled="!companyLayout2.permission.inviteHistory" @click="historyInvite" class="nav-tree__item" size="mini" type="menu" icon="el-icon-document">{{$t('users_btn_invite_history')}}</el-button>
            <!-- <el-button v-if="companyLayout2" @click="editUser" :disabled="disabledBtn || !companyLayout2.permission.editUser" class="nav-tree__item" size="mini" type="menu" icon="el-icon-edit">{{$t('users_btn_edit')}}</el-button> -->
            <el-button v-if="activeBtn && companyLayout2" @click="diactivateUser" :disabled="disabledBtn || !companyLayout2.permission.deactive" class="nav-tree__item" size="mini" type="menu" icon="el-icon-refresh">{{$t('users_btn_deactivate')}}</el-button>
            <el-button v-else @click="activeUser" :disabled="disabledBtn" class="nav-tree__item" size="mini" type="menu" icon="el-icon-refresh">{{$t('users_btn_activate')}}</el-button>
            <!-- <el-button @click="openScheduler" class="nav-tree__item" size="mini" type="menu">{{$t('users_btn_calendar')}}</el-button> -->
            <el-button @click="usersLogHistory" class="nav-tree__item" size="mini" type="menu" icon="el-icon-document">Users Log History</el-button>
          </div>
          <ag-grid-vue style="width: 100%; height: calc(100% - 42px);" class="ag-theme-balham" id="myGrid"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            :getContextMenuItems="getContextMenuItems"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowDragManaged="true"
            :animateRows="true"
            :rowData="rowData"
            :getRowHeight="getRowHeight"
            :rowSelection="rowSelection"
            :floatingFilter="true"
            @selection-changed="onSelectionChanged"></ag-grid-vue>
        </div>
        <!-- [ Tree ] end -->

        <!-- [Tree info] start -->
        <div class="wrap__info">
          <div style="padding-bottom: 10px;">
            <el-button @click="openScheduler" class="nav-tree__item" size="mini" type="menu2" icon="el-icon-menu">{{$t('users_btn_calendar')}}</el-button>
          </div>
          <!--{{activeTab}}-->
          <el-tabs v-model="activeTab" activeName="info" disabled type="border-card" @tab-click="handleClick">
            <!-- Info -->
            <el-tab-pane :label="$t('users_tab_info')" name="info">
              <el-tabs activeName="first">
                <el-tab-pane :label="$t('users_tab_info_first')" name="first">
                  <el-card>
                    <div class="user-info" v-if="showInfo">
                      <div v-if="companyLayout2.companyUserId == info.id" class="user-info__edit">
                        <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="openProfile"></el-button>
                      </div>
                      <h3 class="user-info__title" v-html="info.name"></h3>

                      <div class="user-info__content">
                        <div class="user-info__photo">
                          <img v-if="info.avatarUrl" :src="info.avatarUrl">
                        </div>
                        <div class="user-info__details">
                          <ul>
                            <li v-if="infoStatus == 'Active'"><div class="user-info__details_label">{{$t('users_tab_info_status')}}</div> <span v-html="infoStatus" class="user-info__details_status"></span></li>
                            <li v-else><div class="user-info__details_label">{{$t('users_tab_info_status')}}</div> <span v-html="infoStatus" class="user-info__details_disabled"></span></li>
                            <li><div class="user-info__details_label">{{$t('users_tab_info_email')}}:</div> <span class="user-info__details_email" v-html="info.email"></span></li>
                            <li><div :class="{isEmpty: !info.address}" class="user-info__details_label">{{$t('users_tab_info_address')}}:</div> <span class="user-info__details_all" v-html="info.address"></span></li>
                            <li><div :class="{isEmpty: !info.work_phone}" class="user-info__details_label">{{$t('users_tab_info_workphone')}}:</div> <span class="user-info__details_all" v-html="info.work_phone"></span></li>
                            <li><div :class="{isEmpty: !info.home_phone}" class="user-info__details_label">{{$t('users_tab_info_homephone')}}:</div> <span class="user-info__details_all" v-html="info.home_phone"></span></li>
                            <li><div :class="{isEmpty: !info.phone}" class="user-info__details_label">{{$t('users_tab_info_mobile')}}:</div> <span class="user-info__details_all" v-html="info.phone"></span></li>
                            <li><div :class="{isEmpty: !info.company}" class="user-info__details_label">{{$t('users_tab_info_company')}}:</div> <span class="user-info__details_all" v-html="info.company"></span></li>
                            <li><div :class="{isEmpty: !info.timezoneId}" class="user-info__details_label">{{$t('users_tab_info_timezone')}}:</div> <span class="user-info__details_all" v-html="info.timezoneId"></span></li>

                            <li><div class="user-info__details_label">{{$t('users_tab_info_receiveSystemEmails')}}:</div> <span class="user-info__details_all" v-html="info.mailNotifications ? 'Yes' : 'No'"></span></li>
                            <li><div :class="{isEmpty: !info.companyEmail}" class="user-info__details_label">{{$t('users_tab_info_useAlternativeEmails')}}:</div> <span class="user-info__details_all" v-html="info.companyEmail"></span></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </el-card>
                </el-tab-pane>
                <el-tab-pane :label="$t('users_tab_info_employee')" name="employee">
                  <el-card>
                    Current Service Under Development
                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>

            <!-- Work Day -->
            <el-tab-pane v-if="companyLayout2" :label="$t('users_tab_workday')" name="workDay" work_day_tab_tab_name :disabled="infoStatus == 'InActive' || !companyLayout2.permission.workday">
              <div v-if="showWorkDay">
                <el-tabs v-model="activeWorkDay" @tab-click="handleClickWorkDay">
                  <el-tab-pane :label="$t('general_bu')" name="businessUnitWorkDay">
                    <el-card>
                      <div>
                        <el-row>
                          <el-col :span="24">{{$t('users_tab_workday_description')}}</el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-select v-model="businessUnitId" :placeholder="$t('general_select_bu')" size="mini">
                              <el-option v-for="item in businessUnitList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setBusinessUnitId(item.id)">
                              </el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="12" style="text-align: right;">
                            <el-button @click="saveWorkDayDep" type="primary" size="mini" plain>{{$t('general_save')}}</el-button>
                            <el-button @click="goToWorkDay('business-units')" type="primary" size="mini" plain>{{$t('general_close')}}</el-button>
                          </el-col>
                        </el-row>

                        <el-row :gutter="15" class="list">
                          <el-col :span="12">
                            <h3>{{$t('users_tab_workday_all_task')}}</h3>
                            <!-- {{taskList}} -->
                            <draggable class="list-group" :list="taskListDep" group="people" @change="log">
                              <div
                                      class="list-group-item"
                                      v-for="element in taskListDep"
                                      :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </el-col>
                          <el-col :span="12">
                            <h3>{{$t('users_tab_workday_workday')}}</h3>
                            <!-- {{workDayList}} -->
                            <draggable class="list-group" :list="workDayListDep" group="people" @change="log">
                              <div
                                      class="list-group-item"
                                      v-for="element in workDayListDep"
                                      :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('general_e')" name="engagementWorkDay">
                    <el-card>
                      <div>
                        <el-row>
                          <el-col :span="24">{{$t('users_tab_workday_description')}}</el-col>
                        </el-row>

                        <el-row>
                          <el-col :span="12">
                            <el-select v-model="engagementId" :placeholder="$t('general_select_e')" size="mini">
                              <el-option v-for="item in engagementList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setEngagementId(item.id)">
                              </el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="12" style="text-align: right;">
                            <el-button @click="saveWorkDayEngagement" type="primary" size="mini" plain>{{$t('general_save')}}</el-button>
                            <el-button @click="goToWorkDay('engagements')" type="primary" size="mini" plain>{{$t('general_close')}}</el-button>
                          </el-col>
                        </el-row>

                        <el-row :gutter="15" class="list">
                          <el-col :span="12">
                            <h3>{{$t('users_tab_workday_all_task')}}</h3>
                            <!-- {{taskList}} -->
                            <draggable class="list-group" :list="taskListEngagement" group="people" @change="log">
                              <div
                                      class="list-group-item"
                                      v-for="element in taskListEngagement"
                                      :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </el-col>
                          <el-col :span="12">
                            <h3>{{$t('users_tab_workday_workday')}}</h3>
                            <!-- {{workDayList}} -->
                            <draggable class="list-group" :list="workDayListEngagement" group="people" @change="log">
                              <div
                                      class="list-group-item"
                                      v-for="element in workDayListEngagement"
                                      :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('general_project')" name="projectWorkDay">
                    <el-card>
                      <div>
                        <el-row>
                          <el-col :span="24">{{$t('users_tab_workday_description')}}</el-col>
                        </el-row>

                        <el-row>
                          <!--<el-col style="display:flex;">-->
                          <el-col :span="12">
                            <el-select v-model="projectId" :placeholder="$t('general_select_project')" size="mini">
                              <el-option v-for="item in projectList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setProjectId(item.id)">
                              </el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="12" style="text-align: right;">
                            <el-button @click="saveWorkDay" type="primary" size="mini" plain>{{$t('general_save')}}</el-button>
                            <el-button @click="goToWorkDay('projects')" type="primary" size="mini" plain>{{$t('general_close')}}</el-button>
                          </el-col>
                          <!--</el-col>-->
                        </el-row>


                        <el-row :gutter="15" class="list">
                          <el-col :span="12">
                            <h3>{{$t('users_tab_workday_all_task')}}</h3>
                            <!-- {{taskList}} -->
                            <draggable class="list-group" :list="taskList" group="people" @change="log">
                              <div
                                      class="list-group-item"
                                      v-for="element in taskList"
                                      :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </el-col>
                          <el-col :span="12">
                            <h3>{{$t('users_tab_workday_workday')}}</h3>
                            <!-- {{workDayList}} -->
                            <draggable class="list-group" :list="workDayList" group="people" @change="log">
                              <div
                                      class="list-group-item"
                                      v-for="element in workDayList"
                                      :key="element.name"
                              >
                                {{ element.name }}
                              </div>
                            </draggable>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-tab-pane>

            <!-- HRIS -->
            <el-tab-pane v-if="companyLayout2" :label="$t('users_tab_hris')" name="hris" :disabled="infoStatus == 'InActive' || !companyLayout2.permission.hris">
              <div v-if="showHris" class="hris">
                <div>
                  <el-tabs v-model="hrisTab" activeName='first' @tab-click="handleClick">
                    <el-tab-pane :label="$t('users_tab_hris_rates')" name="first">
                      <el-card>
                        <div class="hris__edit">
                          <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="openHRIS"></el-button>
                        </div>
                        {{$t('users_tab_hris_rates_billable')}}: {{hrisList ? hrisList.ratePerHour : 'Not installed'}} <br>
                        {{$t('users_tab_hris_rates_cost')}}: {{hrisList ? hrisList.costRatePerHour : 'Not installed'}} <br>
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('users_tab_hris_advances')" name="myCashAdvances">
                      <el-card>
                        <div class="tab-wrap">
                          <myCashAdvanceTable ref="myCashAdvances"/>
                        </div>
                      </el-card>
                    </el-tab-pane>
                    <!--<el-tab-pane label="Request Advances" name="myRequestCashAdvances">-->
                      <!--<div class="tab-wrap">-->
                        <!--<myRequestCashAdvanceTable ref="myRequestCashAdvances"/>-->
                      <!--</div>-->
                    <!--</el-tab-pane>-->
                    <el-tab-pane :label="$t('users_tab_hris_expenses')" name="myExpenses">
                      <el-card>
                        <myExpenseTable ref="myExpenses"/>
                      </el-card>
                    </el-tab-pane>
                    <!--<el-tab-pane label="Expense Requests" name="myExpensesRequests">-->
                      <!--<myExpenseRequestTable ref="myExpensesRequests"/>-->
                    <!--</el-tab-pane>-->
                    <!-- <el-tab-pane :label="$t('users_tab_hris_documents')" name="documents">
                    </el-tab-pane> -->
                    <el-tab-pane :label="$t('users_tab_hris_rights')" name="rights">
                      <el-card>
                        <myRights @refreshRowData="refreshRowData" :selectedRow="selectedRow" ref="myRights"/>
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('users_tab_info_workSchedule')" name="workSchedule">
                      <el-card>
                        Current Service Under Development
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('users_tab_info_workRecord')" name="workRecord">
                      <el-card>
                        <work-record/>
                      </el-card>
                    </el-tab-pane>
                  </el-tabs>
                </div>

              </div>
            </el-tab-pane>

            <!-- History -->
            <el-tab-pane v-if="companyLayout2" :label="$t('users_tab_history')" name="history" :disabled="infoStatus == 'InActive'">
              <el-tabs activeName="first">
                <el-tab-pane :label="$t('users_tab_history_first')" name="first">
                  <el-card>
                    <div v-if="showHistory">
                      <historyTab ref="refUserHistory" :selectedUserId="this.selectedUserId"/>
                    </div>
                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>

            <!-- Document -->
            <el-tab-pane v-if="companyLayout2" :label="$t('users_tab_document')" name="document" :disabled="infoStatus == 'InActive' || !companyLayout2.permission.document">
              <el-tabs activeName="first">
                <el-tab-pane :label="$t('users_tab_document_first')" name="first">
                  <el-card>
                    <Document ref="doc"/>
                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>

            <!-- Permissions -->
            <el-tab-pane v-if="companyLayout2" :label="$t('users_tab_permissions')" name="permissions" :disabled="infoStatus == 'InActive' || (!companyLayout2.permission.permission && user.user.id !== selectedUserId)">
              <div v-show="selectedRow.leader" style="padding: 20px; text-align: center;">
                {{$t('users_thisUserIsTheOwnerOfTheCompanyAndCannotChangeTheAccessPermissionLevel')}}
              </div>
              <el-tabs v-show="!selectedRow.leader" v-model="activePermissionTab" @tab-click="handleClickPermissionsTab">
                <el-tab-pane :label="$t('users_tab_permissions_company')" name="companyPermission">
                  <el-card>

                    <Permissions ref="per" :activePermissionTab="activePermissionTab" :userId="selectedUserId" :permissions="companyUsersPermissions" :disabledPermissions="disabledPermissions"/>

                  </el-card>
                </el-tab-pane>
                <el-tab-pane :label="$t('users_tab_permissions_businessUnit')" name="businessUnitPermission">
                  <el-card>

                    <Permissions ref="perBu" :activePermissionTab="activePermissionTab" :userId="selectedUserId" :permissions="companyUsersPermissions" :disabledPermissions="disabledPermissions"/>

                  </el-card>
                </el-tab-pane>
                <el-tab-pane :label="$t('users_tab_permissions_engagement')" name="engagementPermission">
                  <el-card>

                    <Permissions ref="perEng" :activePermissionTab="activePermissionTab" :userId="selectedUserId" :permissions="companyUsersPermissions" :disabledPermissions="disabledPermissions"/>

                  </el-card>
                </el-tab-pane>
                <el-tab-pane :label="$t('users_tab_permissions_project')" name="projectPermission">
                  <el-card>

                    <Permissions ref="perProj" :activePermissionTab="activePermissionTab" :userId="selectedUserId" :permissions="companyUsersPermissions" :disabledPermissions="disabledPermissions"/>

                  </el-card>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>

            <!-- Subscriptions -->
            <el-tab-pane :label="$t('users_tab_subscriptions')" name="subscriptions" v-if="isLeaderCompany">
              <el-tabs v-model="activeSubscriptionTab" @tab-click="handleClickSubscriptions">
                <el-tab-pane :label="$t('users_tab_subscriptions_plans')" name="subscriptions-plans">
                  <SettingsSubscriptions ref="subscriptions"/>
                </el-tab-pane>
                <el-tab-pane :label="$t('users_tab_subscriptions_history')" name="subscriptions-history">
                  <subscription-history ref="subscriptionHistory"/>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>

            <!-- Working hours -->
            <el-tab-pane :label="$t('users_tab_workingHours')" name="workingHours">
              <working-hours ref="workingHours"/>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- [Tree info] end -->
      </div>
    </div>

    <!-- [ Modal button add invite] start -->
    <inviteUserModal ref="inviteUserModal"/>
    <!-- [ Modal button add invite] end -->

    <HistoryInvite ref="modalHistory" :directories="directories"/>

    <LogHistory ref="modalLogHistory"/>

    <!-- [ Modal form Edit User ] start -->
    <EditUser ref="modal" :directories="directories" :companyUserItem="companyUserItem" @selected="selected"/>
    <!-- [ Modal form Edit User ] end -->

    <!-- [ Modal form Profile ] start -->
    <myProfile ref="modal11" :directoriesTimezoneList="timezoneList" @selected="selected"/>
    <!-- [ Modal form Profile ] end -->

    <!-- [ Modal form HRIS ] start -->
    <EditHRIS ref="modalHRIS" :hrisLIst="hrisLIst"/>
    <!-- [ Modal form HRIS ] end -->

    <ChangePressetModal :selectedRows="selectedRows" ref="changePressetModal" @selected="selectedAfterPresset"/>

    <scheduler-modal :selectedUserId="selectedUserId" ref="schedulerModal"/>
  </div>
</template>

<script>
// import Header from '@/components/Header.vue'
// import Menu from '@/components/Menu.vue'
import HistoryInvite from '@/components/users/HistoryInvite.vue'
import LogHistory from '@/components/users/LogHistory.vue'
import EditUser from '@/components/users/EditUser.vue'
import EditHRIS from '@/components/users/EditHRIS.vue'
import inviteUserModal from '@/components/users/inviteUserModal.vue'
import Document from '@/components/users/Document.vue'
import Permissions from '@/components/users/Permissions.vue'
import myCashAdvanceTable from '@/components/cash-davances/myCashAdvanceTable.vue'
// import myRequestCashAdvanceTable from '@/components/cash-davances/myRequestCashAdvanceTable.vue'
import myExpenseTable from '@/components/expenses/myExpenseTable.vue'
import myRights from '@/components/users/myRights.vue'
// import myExpenseRequestTable from '@/components/expenses/myExpenseRequestTable.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import {AgGridVue} from "ag-grid-vue"
import draggable from 'vuedraggable'
import MyProfile from '../components/notifications/MyProfile.vue'
import axios from 'axios'
import ChangePressetModal from "../components/users/ChangePressetModal";
import SettingsSubscriptions from "../components/users/settingsSubscriptions";
import SubscriptionHistory from "../components/users/SubscriptionHistory";
import historyTab from "../components/users/historyTab";
import SchedulerModal from "../components/users/calendar/SchedulerModal";
import WorkingHours from "../components/users/workingHours";
import WorkRecord from '@/components/users/pc/workRecord';
import router from "../router";

export default {
  name: 'Users',
  components: {
    WorkingHours,
    SubscriptionHistory,
    SettingsSubscriptions,
    ChangePressetModal,
    // Header,
    AgGridVue,
    SweetModal,

    // Menu,
    HistoryInvite,
    EditUser,
    draggable,
    myRights,
    MyProfile,
    EditHRIS,
    inviteUserModal,
    Document,
    myCashAdvanceTable,
    // myRequestCashAdvanceTable,
    myExpenseTable,
    // myExpenseRequestTable
    Permissions,
    historyTab,
    SchedulerModal,
    WorkRecord,
    LogHistory,
  },
  created() {


    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    // axios
    //   .post(`/api/v1/tasks/myList?companyId=${this.$route.query.companyId}`)
    //   .then(response => {
    //     this.list1 = response.data.list
    //   })
    //   .catch(error => {
    //     console.log('An error occurred:', error);
    //   });
  },
  computed: {
    companyLeader(){
      return this.$store.getters.getRowDataUsers.filter(user => user.leader)[0]
    },
    rowData() {
      return this.$store.getters.getRowDataUsers
    },
    user() {
      return this.$store.state.user
    },
    hrisList() {
      return this.$store.getters.getHrisList
    },
    companyLayout2() {
      return this.$store.getters.getCompanyLayout
    },
    companyLayout() {
      return this.$store.getters.getMenuStatistics
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true
    };
    this.columnDefs = [
      { field: this.$i18n.t('Users_id'),
        filter: false,
        headerClass: 'id-column',
        width:40,
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.id}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex; justify-content:center;'}
        }
        // headerName: this.$t('my_account_tt_lbl_id')
      },
      { field: this.$i18n.t('Users_name'),
        filter: "agTextColumnFilter",
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.name}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
        // headerName: this.$t('my_account_tt_lbl_name')
      },
      { field: this.$i18n.t('Users_email'),
        filter: false,
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.email}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
        // headerName: this.$t('my_account_tt_lbl_email')
      },
      // { field: "role",
      //   width:100,
      //   filter: false,
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.role}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      //   headerName: this.$t('my_account_tt_lbl_role')
      // },
      // { field: "businessUnits",
      //   width:100,
      //   filter: false,
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.businessUnits}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      //   // headerName: this.$t('my_account_tt_lbl_business_units')
      // },
      { filter: false,
        field: this.$i18n.t('Users_last_login'),
        width:150,
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.lastLogin}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
        // headerName: this.$t('my_account_tt_lbl_last_login')
      },
      { filter: false,
        width:60,
        field: this.$i18n.t('Users_status'),
        cellRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.status == 1 ? 'Active' : 'InActive'}</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'center; display: flex;'}
        }
        // headerName: this.$t('my_account_tt_lbl_last_login')
      }
    ];
    this.rowSelection = "multiple"
    this.defaultColDef = {
      suppressMovable: true,
      suppressMenu: true,
      resizable: true,
      // width: 150,
      filter: true
    };
    this.getRowHeight = params => {
      return 40;
    };
  },
  async mounted() {
    try {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
      await this.gridApi.sizeColumnsToFit();
      if(localStorage.getItem('isWorkDay') === 'projectWorkDayOpen'){
        this.activeTab = 'workDay';
        this.activeWorkDay = 'projectWorkDay'
        await this.$store.dispatch('getRowDataUsers').then(async response =>{
          if(response){
            await this.$store.dispatch('getCompanyLayout').then(async res =>{
              await this.selectCreatedTask(res.companyUserId);
              await this.handleClickWorkDay({name: 'projectWorkDay'}, res.companyUserId)
            });
            console.log('PROMISE FROM ', response)
          }
        });
        await localStorage.removeItem('isWorkDay')
      }else if(localStorage.getItem('isWorkDay') === 'businessUnitWorkDayOpen'){
        this.activeTab = 'workDay';
        this.activeWorkDay = 'businessUnitWorkDay';
        await this.$store.dispatch('getRowDataUsers').then(async response =>{
          if(response){
            await this.$store.dispatch('getCompanyLayout').then(async res =>{
              await this.selectCreatedTask(res.companyUserId);
              await this.handleClickWorkDay({name: 'businessUnitWorkDay'}, res.companyUserId)
            });
            console.log('PROMISE FROM ', response)
          }
        });
        await localStorage.removeItem('isWorkDay')
      }else if(localStorage.getItem('isWorkDay') === 'engagementWorkDayOpen'){
        this.activeTab = 'workDay';
        this.activeWorkDay = 'engagementWorkDay';
        await this.$store.dispatch('getRowDataUsers').then(async response =>{
          if(response){
            await this.$store.dispatch('getCompanyLayout').then(async res =>{
            await this.selectCreatedTask(res.companyUserId);
            await this.handleClickWorkDay({name: 'engagementWorkDay'}, res.companyUserId)
            });
            console.log('PROMISE FROM ', response)
          }
        });
        await localStorage.removeItem('isWorkDay')
      }else{
        await this.$store.dispatch('getRowDataUsers').then(async response =>{
          if(response){
            await this.$store.dispatch('getCompanyLayout').then(async res =>{
              try {
                switch (this.$route.query.activeTab){
                  case 'subscriptions':
                    this.activeTab = 'subscriptions';
                    break;
                }
                await this.selectCreatedTask(res.companyUserId)

              } catch(err){
                console.log(err)
              }
            })
            console.log('PROMISE FROM ', response)
          }
        })
      }
      console.log('this.companyLeader.uId', this.companyLeader.uId)
      console.log('this.user.user.id', this.user.user.id)
      if (this.companyLeader.uId === this.user.user.id){
        this.isLeaderCompany = true
      }
    } catch (err){
      console.log(err)
    }
  },
  data() {
    return {
      disabledPermissions: false,
      activePermissionTab: 'companyPermission',
      selectedUserId: null,
      companyUsersPermissions: [],
      // businessUnitPermissions: [],
      // engagementPermissions: [],
      // projectPermissions: [],
      activeNames: ['1'],
      hrisTab: 'first',
      activeTab: 'info',
      activeSubscriptionTab: 'subscriptions-plans',
      activeWorkDay: 'projectWorkDay',
      // open: false,
      selectedRows: null,
      selectedRow: {},
      isLeaderCompany: false,
      list1: [
        { name: "John", id: 1 },
        { name: "Joao", id: 2 },
        { name: "Jean", id: 3 },
        { name: "Gerard", id: 4 }
      ],
      list2: [
        { name: "Juan", id: 5 },
        { name: "Edgard", id: 6 },
        { name: "Johnson", id: 7 }
      ],

      // Tree
      gridOptions: null,
      gridApi: null,
      getRowHeight:null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowSelection: null,

      companyUserId: null,
      directories: null,
      timezoneList: null,
      companyUserItem: null,

      companyNameSelect: '',

      showWorkDay: false,
      showProfile: true,
      showHris: false,
      showHistory: true,
      // Info
      showInfo: false,
      infoStatus: '',
      activeBtn: true,
      disabledBtn: true,
      info: {
        photo: '@/assets/img/user-default.jpg',
        status: '',
        address: '',
        work_phone: '',
        home_phone: '',
        phone: '',
        company: '',
        avatarUrl: '',

        id: '',
        name: '',
        email: '',
        role: '',
        lastLogin: '',
        timezoneId: '',

        mailNotifications: '',
        companyEmail: '',
      },

      // Invite
      // form: {
      //   inviteEmail: '',
      //   projectId: null,
      //   taskId: null
      // },
      // rules: {
      //   inviteEmail: [
      //     { required: true, message: 'Please input Email address', trigger: 'blur' },
      //     { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
      //   ],
      //   projectId: [
      //     { required: true, message: 'Please input Project', trigger: 'blur' }
      //   ],
      //   taskId: [
      //     { required: true, message: 'Please input Task', trigger: 'blur' }
      //   ],
      // },

      // work day
      projectList: [],
      projectId: null,
      businessUnitList: [],
      engagementList: [],
      businessUnitId: null,
      engagementId: null,
      tList: [],
      tListDep: [],
      tListEngagement: [],
      taskList: [],
      taskListDep: [],
      taskListEngagement: [],
      workDayList:[],
      workDayListDep: [],
      workDayListEngagement: [],

      // hris
      hrisLIst: [],
    }
  },
  methods: {
    historyInvite() {
      // this.$refs['modalHistory'].$refs['modalHistoryInvite'].open()

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/invite/list?companyId=${this.$route.query.companyId}&status=null`)
        .then(response => {
          this.directories = response.data
          this.$refs['modalHistory'].$refs['modalHistoryInvite'].open()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          this.notification("Notification", error.response.data.message, "info");
        });
    },
    usersLogHistory() {
      this.$refs['modalLogHistory'].openModal()
    },
    goToWorkDay(action){
      localStorage.setItem('isWorkDay', 'workDayOpen');
      this.$router.push({name: action, query: {companyId: this.$route.query.companyId}})
    },
    handleClick(tab, event) {
      if(tab.name === 'workDay'){
        // alert('workDay');
        this.getProjectList()
        this.getWorkDayProject(this.$route.query.companyUserId)
      } else if(tab.name === 'hris') {
        this.$store.dispatch('getHrisList')
        this.$store.dispatch('getMenuStatistics')
      } else if(tab.name === 'document') {
        this.$refs['doc'].loadList()
      }else if(tab.name === 'myCashAdvances'){
        this.$refs.myCashAdvances.openTable()
      }else if(tab.name === 'myExpenses'){
        this.$refs.myExpenses.openTable()
      } else if (tab.name === 'permissions') {
        this.activePermissionTab = 'companyPermission'
        this.$refs.per.getCompanyPresset()
        this.getUserPermissions(this.activePermissionTab)
      }else if (tab.name === 'subscriptions') {
        switch(this.activeSubscriptionTab){
          case 'subscriptions-plans':
            this.$refs.subscriptions.loadSubscriptionsList();
            break;
          case 'subscriptions-history':
            this.$refs.subscriptionHistory.loadSubscriptionHistory();
            break;
        }
      } else if (tab.name === 'history') {
        this.$refs['refUserHistory'].reset()
        this.$store.dispatch('getUserHistory', { userId: this.selectedUserId, page: 1 })
        // this.$refs['refUserHistory'].reset()
      } else if (tab.name === 'workingHours') {
        this.$refs.workingHours.loadWorkingHours(this.$route.query.companyUserId)
      }
    },
    handleClickSubscriptions(tab, event) {
      switch(tab.name){
        case 'subscriptions-plans':
          this.$refs.subscriptions.loadSubscriptionsList();
          break;
        case 'subscriptions-history':
          this.$refs.subscriptionHistory.loadSubscriptionHistory();
          break;
      }
    },
    handleClickPermissionsTab(tab){
      switch (tab.name) {
        case 'companyPermission':
          this.getUserPermissions(tab.name)
          this.$refs.per.getCompanyPresset()
          break;
        case 'businessUnitPermission':
          this.getUserPermissions(tab.name)
          this.$refs.perBu.getBusinessUnitPresset()
          break;
        case 'engagementPermission':
          this.getUserPermissions(tab.name)
          this.$refs.perEng.getEngagementPresset()
          break;
        case 'projectPermission':
          this.getUserPermissions(tab.name)
          this.$refs.perProj.getProjectPresset()
          break;
      }
    },
    refreshRowData(){
      this.$store.dispatch('getRowDataUsers').then(response =>{
        this.selectCreatedTask(this.selectedRow.userId)
      })
    },
    refreshUserExpensePageFromHeader(){
      if(this.hrisTab === 'myExpenses'){
        this.handleClick({name:'myExpenses'})
      }
    },
    refreshCashAdvancePage(){
      if(this.hrisTab === 'myCashAdvances'){
        this.handleClick({name:'myCashAdvances'})
      }
    },
    handleClickWorkDay(tab, id){
      if(tab.name === 'projectWorkDay'){
        this.getProjectList();
        this.getWorkDayProject(id)
      }else if (tab.name === 'businessUnitWorkDay'){
        this.getBusinessUnitList()
        this.getWorkDaybusinessUnit(id)
      }else if (tab.name === 'engagementWorkDay'){
        this.getEngagementList()
        this.getWorkDayEngagement(id)
      }
    },
    getProjectList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}`)
              .then(response => {
                console.log('---/projects/list', response.data.list);
                this.projectList = response.data.list
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    getBusinessUnitList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
              .then(response => {
                console.log('---/engagements/list', response.data.list);
                this.businessUnitList = response.data.list
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    getEngagementList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/engagements/list?companyId=${this.$route.query.companyId}`)
              .then(response => {
                console.log('---/engagements/list', response.data.list);
                this.engagementList = response.data.list
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    setProjectId(projectId) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/projectTaskWorkDayItems/directories?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}&projectId=${projectId}&operation=create`)
              .then(response => {
                console.log('---/projectTaskWorkDayItems/directories', response.data.projectTaskList);
                this.tList = response.data.projectTaskList
                this.getWorkDayProject()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    getContextMenuItems(params) {
      if (params.node.data.id !== this.selectedRow.id && this.selectedRows.length === 1) {
        this.gridOptions.api.deselectAll();
      }
      this.selectCreatedTaskByRightClick(params.node.data.id);
      var _this = this;
      var data = params.node.data;
      var contextMenuItemList = [];
      contextMenuItemList.push({
        name: 'Change Presset',
        disabled: false,
        action: function () {
          _this.$refs.changePressetModal.openModal()
        },
        icon: '<i class="el-icon-plus"></i>',
      });
      return contextMenuItemList;
    },
    selectCreatedTaskByRightClick(id) {
      return new Promise ((resolve, reject) => {
        this.gridApi.forEachNode(function (node, index) {
          // CHECK IF USER HAVE ACCESS TO TE ROW
          if (node.data.id === id) {
            // SET TO TRUE IF HAVE ACCESS
            node.setSelected(true);
            resolve(node)
          }
        });
      })
    },
    getWorkDayProject(id){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/projectTaskWorkDayItems/list?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId || id}`)
              .then(response => {
                console.log('---/projectTaskWorkDayItems/list', response.data.list);

                let list = []

                for (let i = 0; i < response.data.list.length; i++ ) {
                  let res = {
                    id: 0,
                    name: '',
                  }

                  res.id = response.data.list[i].id
                  res.name = response.data.list[i].name
                  list.push(res)
                }

                this.workDayList = list

                let listTask = []
                for (var i = 0; i < this.tList.length; i++ ) {
                  var count = 0
                  for (var j = 0; j < this.workDayList.length; j++ ) {
                    if (this.tList[i].projectTask) {
                      if (this.tList[i].projectTask.id == this.workDayList[j].id) {
                        count++
                      }
                    } else {
                      if (this.tList[i].id == this.workDayList[j].id) {
                        count++
                      }
                    }
                  }
                  if (count == 0) {
                    listTask.push(this.tList[i])
                  }
                  count = 0;
                }

                this.taskList = listTask
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    setBusinessUnitId(businessUnitId) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/businessUnitTaskWorkDayItems/directories?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}&businessUnitId=${businessUnitId}&operation=create`)
              .then(response => {
                console.log('---/businessUnitTaskWorkDayItems/directories', response.data.businessUnitTaskList);
                this.tListDep = response.data.businessUnitTaskList
                this.getWorkDaybusinessUnit()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    getWorkDaybusinessUnit(id){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/businessUnitTaskWorkDayItems/list?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId || id}`)
              .then(response => {
                console.log('---/businessUnitTaskWorkDayItems/list', response.data.list);

                let list = []

                for (let i = 0; i < response.data.list.length; i++ ) {
                  let res = {
                    id: 0,
                    name: '',
                  }

                  res.id = response.data.list[i].id;
                  res.name = response.data.list[i].name;
                  list.push(res)
                }

                this.workDayListDep = list

                let listTask = []
                for (var i = 0; i < this.tListDep.length; i++ ) {
                  var count = 0
                  for (var j = 0; j < this.workDayListDep.length; j++ ) {
                    if (this.tListDep[i].businessUnitTask) {
                      if (this.tListDep[i].businessUnitTask.id == this.workDayListDep[j].id) {
                        count++
                      }
                    } else {
                      if (this.tListDep[i].id == this.workDayListDep[j].id) {
                        count++
                      }
                    }
                  }
                  if (count == 0) {
                    listTask.push(this.tListDep[i])
                  }
                  count = 0;
                }

                this.taskListDep = listTask
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    setEngagementId(engagementId) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/engagementTaskWorkDayItems/directories?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}&engagementId=${engagementId}&operation=create`)
              .then(response => {
                console.log('---/engagementTaskWorkDayItems/directories', response.data.engagementTaskList);
                this.tListEngagement = response.data.engagementTaskList
                this.getWorkDayEngagement()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    getWorkDayEngagement(id){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/engagementTaskWorkDayItems/list?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId || id}`)
              .then(response => {
                console.log('---/engagementTaskWorkDayItems/list', response.data.list);

                let list = []

                for (let i = 0; i < response.data.list.length; i++ ) {
                  let res = {
                    id: 0,
                    name: '',
                  }

                  res.id = response.data.list[i].id;
                  res.name = response.data.list[i].name;
                  list.push(res)
                }

                this.workDayListEngagement = list

                let listTask = []
                for (var i = 0; i < this.tListEngagement.length; i++ ) {
                  var count = 0
                  for (var j = 0; j < this.workDayListEngagement.length; j++ ) {
                    if (this.tListEngagement[i].engagementTask) {
                      if (this.tListEngagement[i].engagementTask.id == this.workDayListEngagement[j].id) {
                        count++
                      }
                    } else {
                      if (this.tListEngagement[i].id == this.workDayListEngagement[j].id) {
                        count++
                      }
                    }
                  }
                  if (count == 0) {
                    listTask.push(this.tListEngagement[i])
                  }
                  count = 0;
                }

                this.taskListEngagement = listTask
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    saveWorkDay() {
      let list = []

      for (let i = 0; i < this.workDayList.length; i++ ) {
        list.push(this.workDayList[i].id)
        console.log('---', this.workDayList[i].id);
      }

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/projectTaskWorkDayItems/create?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`, {
                projectTaskIdList: list
              })
              .then(response => {
                console.log('---/projectTaskWorkDayItems/create', response.data);
                this.notification("Success", "Create Workday", "success");
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    saveWorkDayDep() {
      let list = []

      for (let i = 0; i < this.workDayListDep.length; i++ ) {
        list.push(this.workDayListDep[i].id)
        console.log('---', this.workDayListDep[i].id);
      }

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/businessUnitTaskWorkDayItems/create?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`, {
                businessUnitTaskIdList: list
              })
              .then(response => {
                console.log('---/businessUnitTaskWorkDayItems/create', response.data);
                this.notification("Success", "Create Workday", "success");
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    saveWorkDayEngagement() {
      let list = []

      for (let i = 0; i < this.workDayListEngagement.length; i++ ) {
        list.push(this.workDayListEngagement[i].id)
        console.log('---', this.workDayListEngagement[i].id);
      }

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/engagementTaskWorkDayItems/create?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`, {
                engagementTaskIdList: list
              })
              .then(response => {
                console.log('---/engagementTaskWorkDayItems/create', response.data);
                this.notification("Success", "Create Workday", "success");
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    openProfile() {
      // this.$refs['modal11'].openProfile()

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post('/api/v1/users/directories?operation=updateMe')
        .then(response => {
          console.log('---/users/directories', response.data);
          this.timezoneList = response.data.timezoneList
          this.$refs['modal11'].openProfile()
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    openHRIS() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/companyUserHRISData/item?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`)
              .then(response => {
                console.log('---/companyUserHRISData/item', response.data.data);
                this.hrisLIst = response.data.data
                loader.hide()
                this.$refs['modalHRIS'].$refs['editHRIS'].open()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
    // Work Day
    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function(evt) {
      window.console.log(evt);
    },
    //
    // closeModal() {
    //   this.operation = 'company'
    //   this.form.inviteEmail = ''
    //   this.form.projectId = null
    //   this.form.taskId = null
    //   this.$refs['form'].resetFields();
    // },
    // showMenu() {
    //   this.open = true
    //   console.log('---', this.open);
    // },
    // hideMenu() {
    //   this.open = false
    //   console.log('---', this.open);
    // },
    // companyName(name) {
    //   this.companyNameSelect = name
    // },
    inviteUser() {
      console.log('---', 'invite');
      this.$refs.inviteUserModal.openModal();
      // this.$refs.invite.open();
    },
    // submitForm(form) {
    //   this.$refs['form'].validate((valid) => {
    //     if (valid) {
    //       let data = {
    //         email: this.form.inviteEmail,
    //         projectId: null,
    //         projectTaskId: null,
    //         businessUnitId: null,
    //         businessUnitTaskId: null,
    //         engagementId: null,
    //         engagementTaskId: null
    //       }
    //       switch(this.operation){
    //         engagement 'getProjectList':
    //           data.projectId = this.form.projectId
    //           data.projectTaskId = this.form.taskId
    //           break
    //         engagement 'getBusinessUnitList':
    //           data.businessUnitId = this.form.projectId
    //           data.businessUnitTaskId = this.form.taskId
    //           break
    //         engagement 'getEngagementList':
    //           data.engagementId = this.form.projectId
    //           data.engagementTaskId = this.form.taskId
    //           break
    //       }
    //       let loader = this.$loading.show();
    //       axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //       axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //       axios
    //         .post(`/api/v1/companyUsers/inviteUser?companyId=${this.$route.query.companyId}`, data)
    //         .then(response => {
    //           // console.log('---', response.data);
    //           this.$refs.invite.close();
    //           loader.hide()
    //           this.notification("Success", "The invitation has been sent", "success");
    //           this.$refs['form'].resetFields();
    //         })
    //         .catch(error => {
    //           console.log('An error occurred:', error);
    //           this.resendEmail = this.form.inviteEmail
    //           this.$refs.invite.close();
    //           if(error.response.data.message === 'invite_already_sended'){
    //             // this.notification("Notification", error.response.data.message, "info");
    //             this.$refs.reinvite.open();
    //           }
    //           // this.notification("Notification", error.response.data.message, "info");
    //           loader.hide()
    //         });
    //     } else {
    //       console.log('error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // resendSubmit(){
    //       let loader = this.$loading.show();
    //       axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //       axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //       axios
    //               .post(`/api/v1/companyUsers/reinviteUser?companyId=${this.$route.query.companyId}&email=${this.resendEmail}`)
    //               .then(response => {
    //                 console.log('---', response.data);
    //                 this.resendEmail = '';
    //                 this.$refs.reinvite.close();
    //                 loader.hide()
    //                 this.notification("Success", "Invitation sent", "success");
    //                 // setTimeout("location.reload()", 1000);
    //               })
    //               .catch(error => {
    //                 console.log('An error occurred:', error);
    //                 this.$refs.reinvite.close();
    //                 // if(error.response.data.message === 'invite_already_sended'){
    //                 //   this.notification("Notification", error.response.data.message, "info");
    //                 //   this.$refs.reinvite.open();
    //                 // }
    //                 this.notification("Notification", error.response.data.message, "info");
    //                 this.resendEmail = '';
    //                 loader.hide()
    //               });
    // },
    editUser() {
      this.$refs['modal'].$refs['editUserForm'].open()

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyUsers/directories?companyId=${this.$route.query.companyId}&operation=update`)
        .then(response => {
          console.log('---/companyUsers/directories', response.data);
          this.directories = response.data

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUsers/item?companyId=${this.$route.query.companyId}&companyUserId=${this.$route.query.companyUserId}`)
            .then(response => {
              console.log('---/companyUsers/item', response.data);
              this.companyUserItem = response.data.item
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              this.notification("Notification", error.response.data.message, "info");
              loader.hide()
            });
        })
        .catch(error => {
          console.log('An error occurred:', error);
          this.notification("Notification", error.response.data.message, "info");
        });
    },
    iStatus(e) {
      if (e == 1) {
        this.infoStatus = 'Active',
        this.activeBtn = true
      } else {
        this.infoStatus = 'InActive',
        this.activeBtn = false
      }
    },
    activeUser() {
      this.selectedRows = this.gridApi.getSelectedRows();
      let companyUserId = this.selectedRows[0].userId;
      this.disabledBtn = true;

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyUsers/activate?companyUserId=${this.$route.query.companyUserId}&companyId=${this.$route.query.companyId}`)
        .then(response => {
          console.log('---', response.data);
          this.$store.dispatch('getRowDataUsers')
          this.notification("Success", "Active", "success");
          loader.hide()
          setTimeout(() => {
            this.selectCreatedTask(this.selectedRow.userId)
          }, 2000);
        })
        .catch(error => {
          console.log('An error occurred:', error);
          // if (error.response.data.message === "unable_to_deactivate_yourself") this.notification("Notification", "unable_to_deactivate_yourself", "info");
          loader.hide()
        });
    },
    diactivateUser() {
      this.selectedRows = this.gridApi.getSelectedRows();
      let companyUserId = this.selectedRows[0].userId;
      this.disabledBtn = true;

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyUsers/deactivate?companyUserId=${this.$route.query.companyUserId}&companyId=${this.$route.query.companyId}`)
        .then(response => {
          console.log('---', response.data);
          this.$store.dispatch('getRowDataUsers')
          this.notification("Success", "Deactivate", "success");
          loader.hide()
          setTimeout(() => {
            this.selectCreatedTask(this.selectedRow.userId)
          }, 2000);
        })
        .catch(error => {
          console.log('An error occurred:', error.response.data.message);
          // if (error.response.data.message === "unable_to_deactivate_yourself") this.notification("Notification", "unable_to_deactivate_yourself", "info");
          loader.hide()
        });
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    selected(id) {
      setTimeout(() => {
        this.selectCreatedTask(this.selectedRow.userId)
      }, 2300);
    },
    selectedAfterPresset(){
      this.$store.dispatch('getRowDataUsers').then(response =>{
        if(response){
          this.$store.dispatch('getCompanyLayout').then(res =>{
            this.selectCreatedTask(res.companyUserId)
          });
          console.log('PROMISE FROM ', response)
        }
      })
    },
    // [ Tree ] start
    selectCreatedTask(id){
      this.gridApi.forEachNode(function (node) {
        console.log("NODE DATA", node.data.userId)
        console.log("NODE DATA ID COMPARE", id)
        if (node.data.userId === id) {
          node.setSelected(true);
          console.log("NODE SELECTED")
        }
      });
    },
    onBtSuppressRowDrag() {
      this.gridApi.setSuppressRowDrag(true);
    },
    onBtShowRowDrag() {
      this.gridApi.setSuppressRowDrag(false);
    },
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      this.selectedRow = this.selectedRows[0];
      this.selectedUserId = this.selectedRows[0].uId
      console.log('---ROW', this.selectedRows);

      this.info.status = this.selectedRows[0].status;
      this.info.address = this.selectedRows[0].address;
      this.info.work_phone = this.selectedRows[0].work_phone;
      this.info.home_phone = this.selectedRows[0].home_phone;
      this.info.phone = this.selectedRows[0].phone;
      this.info.company = this.selectedRows[0].company;

      this.info.id = this.selectedRows[0].userId;
      this.info.name = this.selectedRows[0].name;
      this.info.email = this.selectedRows[0].email;
      this.info.role = this.selectedRows[0].role;
      this.info.lastLogin = this.selectedRows[0].lastLogin;
      this.info.avatarUrl = this.selectedRows[0].avatarUrl;
      this.info.timezoneId = this.selectedRows[0].timezoneId;


      this.info.mailNotifications = this.selectedRows[0].mailNotifications;
      this.info.companyEmail = this.selectedRows[0].companyEmail;

      // localStorage.setItem('companyUserId', selectedRows[0].userId)
      this.$router.push(`/users?companyId=${this.$route.query.companyId}&companyUserId=${this.selectedRows[0].userId}`);
      this.disabledBtn = false;
      if(this.activeTab === 'workDay'){
        let ojActiveTab = {
          name: this.activeTab
        };
        this.handleClick(ojActiveTab);
        console.log('this.activeBtn', this.activeTab)
      }
      if(this.activeTab === 'document'){
        this.$refs['doc'].loadList()
      }
      if(this.activeTab === 'history'){
        this.$refs['refUserHistory'].reset()
        this.$store.dispatch('getUserHistory', { userId: this.selectedUserId, page: 1 })
        // this.$refs['refUserHistory'].reset()
      }
      if(this.activeTab === 'permissions'){
        if (!this.companyLayout2.permission.permission && this.user.user.id !== this.selectedUserId) {
          this.activeTab = 'info'
        }
        this.getUserPermissions(this.activePermissionTab)
      }

      if (!this.companyLayout2.permission.permission && this.user.user.id === this.selectedUserId) {
        this.disabledPermissions = true
      } else {
        this.disabledPermissions = false
      }

      // work day
      // this.projectList = []
      this.projectId = null
      this.taskList = []
      this.workDayList = []

      // Status User
      this.iStatus(this.info.status);

      this.showInfo = true
      this.showHris = true
      this.showWorkDay = true

      switch (this.activeTab) {
        case 'hris':
          this.$store.dispatch('getHrisList');
          break;
        case 'subscriptions':
          switch(this.activeSubscriptionTab){
            case 'subscriptions-plans':
              this.$refs.subscriptions.loadSubscriptionsList();
              break;
            case 'subscriptions-history':
              this.$refs.subscriptionHistory.loadSubscriptionHistory();
              break;
          }
        break;
        case 'workingHours':
          this.$refs.workingHours.loadWorkingHours(this.$route.query.companyUserId);
        break;
      }
    },
    getUserPermissions(tabName) {
      console.log('TAAAAB', tabName)
      let url = ''
      switch (tabName) {
        case 'companyPermission' :
          url = `/api/v1/companyUsers/userPermissions?companyId=${this.$route.query.companyId}&userId=${this.selectedUserId}`
          break;
        case 'businessUnitPermission':
          url = `/api/v1/businessUnits/userPermissions?companyId=${this.$route.query.companyId}&userId=${this.selectedUserId}`
          break;
        case 'engagementPermission':
          url = `/api/v1/engagement/userPermissions?companyId=${this.$route.query.companyId}&userId=${this.selectedUserId}`
          break
        case 'projectPermission':
          url = `/api/v1/projects/userPermissions?companyId=${this.$route.query.companyId}&userId=${this.selectedUserId}`
          break
      }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(url)
          .then(response => {
            console.log('---', response.data)
            // this.companyUsersPermissions = response.data.list
            if (response.data.list.length > 0) {
              this.companyUsersPermissions = response.data.list
            } else {
              let data = {
                companyId: +this.$route.query.companyId,
                // permissionPreset: {},
                permissionsIdArr: [],
                presetId: 0,
                userId: this.selectedUserId
              }
              this.companyUsersPermissions = []
              this.companyUsersPermissions.push(data)
            }
            loader.hide();
            console.log('this.companyUsersPermissions', this.companyUsersPermissions)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error)
          });
    },
    // openDialog(){
    //   this.$emit('openChat2')
    // }
    // [ Tree ] end
    openScheduler() {
      this.$refs.schedulerModal.openModal()
    }
  },
}
</script>

<style lang="scss" scoped>
  .sweet-modal-overlay{
    z-index:1000;
  }
.users {
  background: #DfE8F0;
  height: 100vh;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

// [ Wrapper ] start
.wrap {
  display: flex;
  width: 100%;
  padding: 20px 10px 10px 10px;
}
// [ Wrapper ] end

// [ Tree ] start
.wrap__tree {
  width:100%;
  height:100%;
  max-width: 700px;
  min-width:800px;
  min-height:100%;
  padding: 0 10px 0 0;
}
// [ Tree ] end

/deep/.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell{
  padding-left:0;
}

// [ Tree info] start
.wrap__info {
  width:100%;
  // max-width: 700px;
  min-width:600px;
  height:100%;
  padding: 0px 10px 10px 10px;
}
.user-info {
  &__edit {
    position: absolute;
    top: 25px;
    right: 25px;
  }
  &__title {
    margin-top: 0;
  }
  &__content {
    display: flex;
  }
  &__photo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-right: 20px;
    background: url('~@/assets/img/user-default.jpg');
    background-size: cover;
    img {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      // background: url('~@/assets/img/user-default.jpg');
      background-size: cover;
    }
  }
  &__details {
    position: relative;
    .isEmpty {
      color: #ccc
    }
    &_label {
      display: inline-block;
      width: 180px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      color: #888;
      li {
        margin-bottom: 8px;
        span {
          font-weight: 500;
        }
      }
    }
    &_email {
      font-weight: bold;
      background: #888;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_status {
      font-weight: bold;
      background: #5cb85c;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_disabled {
      font-weight: bold;
      background: red;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_all {
      font-weight: bold;
    }
  }
}
.hris {
  &__edit {
    position: absolute;
    top: 25px;
    right: 25px;
  }
}
// [ Tree info] end

// [ Nav tree ] start
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
// [ Nav tree ] end

.el-tabs--border-card {
    min-height: 97%;
    max-height: 97%;
    overflow-x:hidden;
}

// Work Day
.list {
  h3 {
    margin-top: 0;
    font-size: 14px;
    color: #909399;
  }
  &-group {
    &-item {
      padding: 7px;
      margin-bottom: -1px;
      border: 1px solid rgba(0,0,0,.125);
      background: #edeef0;
      // border-bottom: none;
      cursor: pointer;
      // &:last-child {
      //   border-bottom: 1px solid rgba(0,0,0,.125);
      // }
    }
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
  .drag-title{
      margin-left:20px;
  }
  .list-group{
    max-height:500px;
    overflow-x:hidden;
  }

  /deep/.el-tabs--border-card>.el-tabs__content {
    height: 82vh !important;
  }
</style>
